import { useQuery } from '@tanstack/react-query';
import { useWoody } from '../../woody/woody.js';
import { multiplayerQueryKeys } from './multiplayerQueryKeys.js';
import { isQueryEnabled } from '@fabric-app/queries/utilities';
import { useContextAccessToken } from '../../permission/contexts/AnonShareTokenContext.js';

const useQueryMultiplayerSession = (request, queryOptions) => {
  const { client } = useWoody();
  const accessToken = useContextAccessToken();
  const query = useQuery({
    queryKey: multiplayerQueryKeys.session(request),
    queryFn: async () => {
      return client.v2("/v2/jamsocket/authorization", {
        method: "post",
        body: {
          resourceId: request.resourceId
        },
        query: {
          accessToken
        }
      });
    },
    refetchOnMount: "always",
    ...queryOptions,
    enabled: isQueryEnabled([
      !!request,
      queryOptions?.enabled
    ])
  });
  return query;
};

export { useQueryMultiplayerSession };
//# sourceMappingURL=useQueryMultiplayerSession.js.map
